import {
  AvroOptional,
  log as logRNVJApplyButtonShowEvent,
  type RNApplyButtonTypeV4,
} from "@indeed/signals-schema/com/indeed/signals/schema/viewjob/RNVJApplyButtonShowEventV4";

import { getDeviceProperties } from "../../../../../../shared/logging/LoggableDeviceProperties";

/**
 * Type for button dimensions to log
 */
export interface ButtonDimensions {
  srcWidth?: number;
  srcHeight?: number;
  iaButtonX?: number;
  iaButtonY?: number;
  iaButtonWidth?: number;
  iaButtonHeight?: number;
}

/**
 * Logs the visibility of an apply button with its dimensions
 *
 * @param jobKey - The job key
 * @param buttonType - The type of button (indeedApply or thirdParty)
 * @param tk - The tracking key
 * @param dimensions - Optional dimensions of the button
 */
export function logApplyButtonShowEvent(
  jobKey: string,
  buttonType: keyof typeof RNApplyButtonTypeV4,
  tk?: string,
  dimensions?: ButtonDimensions,
): void {
  try {
    logRNVJApplyButtonShowEvent({
      deviceProperties: getDeviceProperties(),
      jobkey: jobKey,
      tk: AvroOptional.string(tk),
      buttonType: buttonType,
      srcWidth: dimensions?.srcWidth !== undefined ? AvroOptional.long(dimensions.srcWidth) : null,
      srcHeight:
        dimensions?.srcHeight !== undefined ? AvroOptional.long(dimensions.srcHeight) : null,
      iaButtonX:
        dimensions?.iaButtonX !== undefined ? AvroOptional.long(dimensions.iaButtonX) : null,
      iaButtonY:
        dimensions?.iaButtonY !== undefined ? AvroOptional.long(dimensions.iaButtonY) : null,
      iaButtonWidth:
        dimensions?.iaButtonWidth !== undefined
          ? AvroOptional.long(dimensions.iaButtonWidth)
          : null,
      iaButtonHeight:
        dimensions?.iaButtonHeight !== undefined
          ? AvroOptional.long(dimensions.iaButtonHeight)
          : null,
    });
  } catch (error) {
    // TODO: log error to signals?
    console.error("Failed to log apply button visibility:", error);
  }
}
